module.exports = __webpack_public_path__ + "img/icon-home-person.b0e498ee.svg";